import { render, staticRenderFns } from "./AgencyBankInfoEdit.vue?vue&type=template&id=45098b13&scoped=true&"
import script from "./AgencyBankInfoEdit.vue?vue&type=script&lang=js&"
export * from "./AgencyBankInfoEdit.vue?vue&type=script&lang=js&"
import style0 from "./AgencyBankInfoEdit.vue?vue&type=style&index=0&id=45098b13&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45098b13",
  null
  
)

export default component.exports